export default (store) => {
  const routes = [
    {
      path: '/:prefix(test)?/metrics/gen',
      name: 'MetricsList',
      meta: {
        displayNavigationDrawer: true,
        displayOrganization: true,
        parent: 'MetricsList',
        requireAuth: true,
        requireAccount: true,
        use: ['ax'],
        title: 'Resumen emisión'
      },
      component: () => import('@/modules/metrics/MetricsList')
    },
    {
      path: '/:prefix(test)?/metrics/rec',
      name: 'RecMetricsList',
      meta: {
        displayNavigationDrawer: true,
        displayOrganization: true,
        parent: 'MetricsList',
        requireAuth: true,
        requireAccount: true,
        use: ['ax'],
        title: 'Resumen recepción'
      },
      component: () => import('@/modules/metrics/MetricsList')
    },
    {
      path: '/:prefix(test)?/metrics/store-sales',
      name: 'StoreSales',
      meta: {
        displayNavigationDrawer: true,
        displayOrganization: true,
        parent: 'MetricsList',
        requireAuth: true,
        requireAccount: true,
        use: ['ax'],
        permissionsRequired: ['view_metrics_branches'],
        title: 'Ventas por tienda'
      },
      component: () => import('@/modules/metrics/StoreSales')
    },
    {
      path: '/:prefix(test)?/metrics/organization-sales',
      name: 'OrganizationSales',
      meta: {
        displayNavigationDrawer: true,
        displayOrganization: true,
        parent: 'MetricsList',
        requireAuth: true,
        requireAccount: true,
        use: ['ax'],
        permissionsRequired: ['view_metrics_account'],
        title: 'Ventas de la organización'
      },
      component: () => import('@/modules/metrics/OrganizationSales')
    },
    {
      path: '/:prefix(test)?/metrics/sales-report',
      name: 'SalesReport',
      meta: {
        displayNavigationDrawer: true,
        displayOrganization: true,
        parent: 'MetricsList',
        requireAuth: true,
        requireAccount: true,
        use: ['ax'],
        permissionsRequired: ['view_metrics_account'],
        title: 'Reporte de ventas'
      },
      component: () => import('@/modules/metrics/SalesReport')
    }
  ]
  return routes
}